/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowForward, MdArrowBack } from 'react-icons/md';
import useAuth from '../../Hooks/useAuth';
import { CarbonButton } from '../../Utils/generalStyles';
import useAxiosPrivate from '../../Hooks/useAxiosPrivate';
import useTable from '../../Hooks/useTable';
import useDeviceDetect from '../../Hooks/checkDevice';
import LoadingSection from '../Loading';
import {
  CardImage,
  CardInfotext,
  CardNftID,
  GalleryCard,
  GalleryContainer,
  GalleryHeader,
  GalleryImageWrapper,
  GalleryWrapper,
  NoWalletTextBig,
  NoWalletTextSmall,
  NoWalletTextWrapper,
  NoWalletWrapper,
  MyPaginate,
  PaginateButton,
  GalleryAmountText,
} from './galleryElements';

// Temp
import img1 from '../../Images/exampleNFT.png';
import img2 from '../../Images/exampleNFT2.png';

const index = () => {
  const navigate = useNavigate();
  const { auth, setAuth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const { isMobile } = useDeviceDetect();

  const [hasWallet, setHasWallet] = useState(false);
  const [ownedNfts, setOwnedNfts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(false);

  const [page, setPage] = useState(1);
  const { slice, range } = useTable(ownedNfts, page, 6);

  const currentTime = new Date().getUTCHours();

  const GetDetailsOfNfts = () => {
    if (auth.owned) {
      setLoading(false);
      return setOwnedNfts(auth.owned);
    }

    return axiosPrivate.post('/detailsOfNfts', JSON.stringify({
      sender: auth.wallet,
    }), {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then((res) => {
      if (res.data.status === 'error') {
        console.log('error when getting owned nfts');
      } else {
        setOwnedNfts(res.data.nfts);
        setAuth((prev) => ({
          ...prev,
          owned: res.data.nfts,
        }));
      }
      setLoading(false);
    }).catch((error) => {
      setLoading(false);
      setApiError(true);
      console.error(error);
    });
  };

  useEffect(() => {
    if (!auth.wallet) setHasWallet(false);
    else {
      setHasWallet(true);
      GetDetailsOfNfts();
    }
  }, []);

  return (
    <GalleryContainer>
      <GalleryWrapper>
        <GalleryHeader>Owned NFTs</GalleryHeader>
        {hasWallet ? (
          loading
            ? <LoadingSection isSmall />
            : (ownedNfts.length > 0 ? (
              <>
                <GalleryAmountText>{`Total owned NFTs: ${ownedNfts.length}`}</GalleryAmountText>
                <GalleryImageWrapper>
                  {slice.map((nft, number) => (
                    <GalleryCard onClick={() => navigate(`/gallery/${nft.NFT_ID}`, { state: ownedNfts[(page - 1) * 6 + number] })} key={nft.NFT_ID}>
                      <CardNftID>{`NFT #${nft.NFT_ID}`}</CardNftID>
                      <CardInfotext>Details</CardInfotext>
                      <CardImage alt="nft image" src={currentTime > 19 || currentTime < 7 ? img2 : img1} />
                    </GalleryCard>
                  ))}
                </GalleryImageWrapper>
                <MyPaginate
                  breakLabel={isMobile ? '' : '...'}
                  onPageChange={(e) => setPage((e.selected) + 1)}
                  pageRangeDisplayed={isMobile ? 1 : 2}
                  marginPagesDisplayed={isMobile ? 1 : 2}
                  pageCount={range.length}
                  renderOnZeroPageCount={null}
                  nextLabel={(
                    <PaginateButton>
                      <MdArrowForward />
                    </PaginateButton>
                    )}
                  previousLabel={(
                    <PaginateButton>
                      <MdArrowBack />
                    </PaginateButton>
                    )}
                />
              </>
            ) : (apiError ? (
              <NoWalletWrapper>
                <NoWalletTextWrapper>
                  <NoWalletTextBig>Error when checking owned NFTs</NoWalletTextBig>
                  <NoWalletTextSmall>
                    Please refresh the page and check again
                  </NoWalletTextSmall>
                </NoWalletTextWrapper>
              </NoWalletWrapper>
            ) : (
              <NoWalletWrapper>
                <NoWalletTextWrapper>
                  <NoWalletTextBig>You dont have any NFTs</NoWalletTextBig>
                  <NoWalletTextSmall>
                    Please check your gallery when you have Carbon Collectible NFTs
                  </NoWalletTextSmall>
                </NoWalletTextWrapper>
              </NoWalletWrapper>
            )))
        ) : (
          <NoWalletWrapper>
            <NoWalletTextWrapper>
              <NoWalletTextBig>No wallet connected</NoWalletTextBig>
              <NoWalletTextSmall>
                Please link your wallet to see owned NFTs
                in your profile section
              </NoWalletTextSmall>
              <CarbonButton style={{ marginTop: '25px' }} onClick={() => navigate('/profile')} colored>Check your profile</CarbonButton>
            </NoWalletTextWrapper>
          </NoWalletWrapper>
        )}
      </GalleryWrapper>
    </GalleryContainer>
  );
};

export default index;
